// GET OTP Handler
export const GET_OTP = "GET_OTP";
export const GET_OTP_ERROR = "GET_OTP_ERROR";
export const GET_OTP_LOADING = "GET_OTP_LOADING";
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";

// Verify OTP Handler
export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_LOADING = "VERIFY_OTP_LOADING";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";

// Verify USER
export const VERIFY_USER = "VERIFY_USER";
export const VERIFY_USER_SUCCESS = "VERIFY_USER_SUCCESS";
export const VERIFY_USER_ERROR = "VERIFY_USER_ERROR";

// Get Current User
export const GET_CURRENT_USER = "GET_CURRENT_USER";

// Logout User
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";
